<template>
  <div class="container is-fluid">
      <div class="columns">
        <div class="column" style="font-family: Helvetica">
          <section id="about-anchor" ref="about-anchor" class="hero">
            <div class="hero-body">
              <p class="title has-text-white">Sculptures</p>
              <p class="subtitle has-text-white">
                Viscuso's Sculptures
                 <br/><br/>
                For purchase proposals and custom productions, please <router-link class="link" :to="{ name: 'Contact' }">contact</router-link> directly Mr. Viscuso.
                
              <ul>
              <ul>
              <br />
              <li><router-link class="link" :to="{ name: 'SculpturesPdf' }">Catalogue</router-link></li>
              <li><router-link class="link" :to="{ name: 'SculpturesOtherCriticisms' }">Other criticisms</router-link></li>
              <li><router-link class="link" :to="{ name: 'SculpturesArticles' }">Articles</router-link></li>
              <li><a href="https://www.youtube.com/watch?v=qEPEwvc6gwk" target="_blank">Video</a></li>
              <li><a href="mailto:emanueleviscuso@gmail.com?subject=Price Request for sculptures" target="_blank" >Send Price Request</a></li>
              </ul>
              </ul>
              </p>
            </div>
          </section>
          <h2 class="abouttext">
            <h3></h3>
          <p style="font-weight: bold;" >Milan airport, The open city of our human becoming<br/>Criticts 15 January 1988 Pierre Restany </p> <br/> <br/> 
          The sculptures of Emanuele Viscuso speak of movement and rhythm, of harmony and therefore of music.<br/> Of solid music: the artist’s aim is to project his modular discourse into a fourth dimension. Indeed, his assemblages of modular elements in progressive series seem to develop under the influence of an immanent fatality, the Spiral.<br/> The accordion-like opening of the structures alludes to the unlimited opening of a mental infinity. Reason seems to prevail over the senses, but this apparent rigour conceals a clear awareness of the structural risk. <br/><br/>Viscuso’s forms, folded shells or endless Jacob’s ladders are the product of a “careful dosing of calculations and other alternatives”. The poetic style of Viscuso plays on the theme of the uncertain: during the creation of the work, and the dualistic possibilities of choice are constant. The modular effect springs from the use of this binary calculation in the continuity of the formal discussion. The “harmonic” control of the open structures puts one in mind of the self-discipline of musical composition; Viscuso’s compositions, based on wood or metallic modular elements, remain waiting. They are not “finished” or closed in a self-sufficient totality. They remain open to other changes, successions, developments. Their presence in space is not perceived solely in the present. They also live in accordance with the law of a hypothetical future, a becoming, a permanent potential for transformation and therefore enable us to think of all the other possibilities of existence they contain in their “being today”. The uncertain is a perpetual invitation to dream. These harmonic, calculated, balanced sculptures are also the bridge of sighs of our imagination. They have within them a supplement of imagination creating a halo of poetry. A rarefied space and one that is highly fragile but present and strong in its allusive dimension. The architectural dream can become an optical illusion: the artist expects to see his sculptures fly. Why not! We, we few believers, or perhaps non-believers, we well know that miracles arise by pure coincidence from situations of daily routine. All it takes is an uncertain parameter and a little creative imagination to destroy the order of things.<br/><br/> Oh Lord! It’s not that Viscuso takes himself for Jesus Christ, but his existential commitment is almost of a moral order. “I am an artist”, says Viscuso, “because this enables me to create… creating is something we all do even if we do not all of us realise that the act of creation is in the first place a divine prerogative”. We are thus on the spiritual heights, at the limit of poetic access and metaphysical discourse. Through God and harmony, the artist’s modular discourse takes on its true, positive dimension. Viscuso’s discourse is a meditation on being, an optimistic thinking about the poetic openness of the collective awareness. All of us can create, but great awareness and great responsibility are rare things, and serious things.<br/> The passage of art of all through art for oneself or for a few corresponds to a fine network of complex motivations. The fabric of communication is made up of impulses of genius and direct exchanges, sometimes realist and trivial. Taking on the risk of beauty implicates what lies beyond calculation, the considering of the infinite possibilities of the soul. This is undoubtedly called faith and Viscuso is a man of faith. The titles of his works speak by themselves: “Song of a happy dinosaur”, “Sound of a shell”, “Away all cares”, “Squaring of the circle”.<br/><br/> The metaphors are broad and this dimension of the infinite creates a willingness and poetic openness in the formal rigour. These fine musical images can be studies of a skyscraper or elements of street furniture, but they will always remain in my mind as a memory of happiness, a happiness born of a marriage between willingness and desire, reason and sentiment. Emanuele Viscuso’s fourth dimension is the free territory of all the dreams of human beauty, elegance in proportions, dignity in spiritual perspectives. Viscuso’s sculpture shares with music this blend inspired by the heart and mind, by sensibility and the spirit: it is the open city of out human becoming.
          <br/><br/>
          </h2>
        </div>
        <div class="column" style="min-height: 1500px">
        <img
          class="bigimage"
            src="images/Malpensa.jpg"
            alt="Emanuele Viscuso"
            align="left"
            style="margin: 300px 20px"
          /><br />
          <img
          class="bigimage"
            src="sculptures_photos\fiberglass/10952_230642387176_668452176_4681287_2761960_n.jpg"
            alt="Emanuele Viscuso"
            align="left"
            style="margin: 50px 20px"
          /><br />
          <img
          class="midimage"
            v-prlx="{
              mobileMaxWidth: 500,
              speed: 0.5,
              fromBottom: false,
              preserveInitialPosition: true,
            }"
            src="sculptures_photos\fiberglass/10952_230642407176_668452176_4681290_7184184_n.jpg"
            alt="Emanuele Viscuso"
            align="left"
            contain
            style="margin: -100px 0px"
          />
          <img
          class="bigimage"
            src="sculptures_photos\various_materials/10952_231434957176_668452176_4692409_6322593_n.jpg"
            alt="Emanuele Viscuso"
            align="right"
            contain
            style="margin: 10px -20px"
          /><br />
          <br />
          
        </div>
        
      </div>
      
    </div>
</template>

<script>
export default {
  name: "Sculptures",
  components: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #040303;
  background-attachment: fixed;
  background-size: cover;
  color: #fff;
}

.link {
  color: #9dc7de;
  transition: 0.3s color ease;

  &:hover {
    color: #e48353;
  }
}

a {
  color: #9dc7de;
  transition: 0.3s color ease;
}
a:hover {
  color: #e48353;
}
.bigimage {
  width: 80%;
}

.midimage {
  width: 50%;
}

.abouttext {
  font-family: "Helvetica";
  font-size: 1.8em;
  text-align: justify;
}

h1 {
  margin-top: 2rem;
  z-index: 10;
  position: absolute;
}
</style>
